import {
  isSituationField,
  isSpecialRelationFieldByColumnJson
} from 'shared/utils/specialRelationFields/specialRelationFields'
import { FieldType, FilterFieldType } from '../../shared/fields'
import { DataFieldComponent, DataFieldLayout } from '../../types'

export function getDefaultDataFieldLayout(
  type?: FieldType,
  columnJson?: string
): DataFieldLayout {
  if (columnJson && isSituationField(columnJson)) {
    return {
      component: DataFieldComponent.StandardMultiselection,
      filteraction: globalThis.situationFilterFilteractionUuid
    }
  }

  if (columnJson && isSpecialRelationFieldByColumnJson(columnJson)) {
    return {
      component: DataFieldComponent.AutocompleteUniselection
    }
  }

  switch (type) {
    case FilterFieldType.Datetime:
      return { component: DataFieldComponent.DatePicker }
    case FilterFieldType.Relation:
      return { component: DataFieldComponent.AutocompleteMultiselection }
    case FilterFieldType.Uuid:
      return { component: DataFieldComponent.Unifree }
    default:
      return { component: DataFieldComponent.Unifree }
  }
}
